module.exports = __webpack_public_path__ + "img/thumb_aula35.91f591a1.jpg";